import { AloftPrice } from '@aloft/toolkit-shared';

import { CostApproachSummaryRollupRow } from './CostApproachSummaryRollupRow.js';

export const CostApproachSummaryTotalCostNew = ({
  totalEstimatedCostNew,
}: {
  totalEstimatedCostNew?: AloftPrice;
}) => (
  <CostApproachSummaryRollupRow
    label="Total Estimate Cost-New"
    value={totalEstimatedCostNew ? `= ${totalEstimatedCostNew?.toString(true)}` : ''}
  />
);
